import Api from '@/services/Api';
import axios from 'axios';
import Router from '../router';

let currentRequest = null;

export default {
  // area?: { N: Number, S: Number, W: Number, E: Number }
  getSensors(area) {
    this.cancelCurrentRequest('Cancelled by new request.');

    let params = '';
    if (area !== undefined) {
      params = `${area.N},${area.W},${area.E},${area.S}`;
    }
    currentRequest = axios.CancelToken.source();
    return Api()
      .get(
        `/geo/${params}`,
        { cancelToken: currentRequest.token },
      );
  },

  // id: number
  getSensor(id) {
    return Api()
      .get(`/device/${id}`)
      .catch(() => {
        Router.push({ name: '404' });
        throw new Error(`No sensor with id ${id}`);
      });
  },

  // id: number, from: timestamp, to: timestamp, type?: string
  getHistoricalData(id, from, to, type) {
    return Api()
      .get(
        `/device/${id}/history/${from},${to}`,
        { params: { type } },
      );
  },

  // msg: string
  cancelCurrentRequest(msg) {
    if (currentRequest) {
      currentRequest.cancel(msg);
    }
  },
};
